import { render, staticRenderFns } from "./AddMovie.vue?vue&type=template&id=20859ea4"
import script from "./AddMovie.vue?vue&type=script&lang=js"
export * from "./AddMovie.vue?vue&type=script&lang=js"
import style0 from "./AddMovie.vue?vue&type=style&index=0&id=20859ea4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports